import { cn } from "@/lib/utils";

interface LogoProps {
  /**
   * Couleur du logo. Utilise currentColor par défaut pour hériter de la couleur du texte parent.
   * Peut être surchargée avec des classes Tailwind comme "text-green-night", "text-green", etc.
   */
  color?: string;
  /**
   * Taille du logo. Par défaut: "default" (w-12 h-12).
   * Options: "sm", "md", "lg", "xl", ou une taille personnalisée via className.
   */
  size?: "sm" | "md" | "default" | "lg" | "xl";
  /**
   * Classes CSS supplémentaires
   */
  className?: string;
}

const sizeClasses = {
  sm: "w-8 h-8",
  md: "w-10 h-10",
  default: "w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16",
  lg: "w-16 h-16 sm:w-20 sm:h-20",
  xl: "w-24 h-24 sm:w-28 sm:h-28",
};

export const Logo = ({ color, size = "default", className }: LogoProps) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="300 200 400 360"
      preserveAspectRatio="xMidYMid meet"
      xmlSpace="preserve"
      className={cn(sizeClasses[size], color || "text-green-night", "m-0 p-0", className)}
      style={{ display: "block", margin: 0, padding: 0 }}
      fill="currentColor"
      aria-label="RAKB Logo"
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
        opacity="1.000000"
        d="
M420.128448,328.142090
	C437.193726,309.615051 458.334534,300.079346 482.847839,299.993134
	C513.189819,299.886383 537.157959,313.472198 555.119873,337.850861
	C560.254456,344.819672 565.322876,351.943695 572.240540,357.300110
	C594.445374,374.493561 628.352417,364.077545 638.625427,337.013519
	C649.597595,308.107574 627.891235,276.288208 596.856018,276.225555
	C530.034241,276.090637 463.212036,276.185883 396.390015,276.201721
	C390.290375,276.203186 390.056641,276.522430 390.056061,283.376801
	C390.049438,362.529266 390.045349,441.681702 390.028564,520.834167
	C390.026642,529.912598 389.874817,530.015442 380.780457,530.000183
	C372.115326,529.985718 363.447845,529.887329 354.785919,530.057373
	C350.343658,530.144592 348.627625,528.511414 348.632324,523.902344
	C348.724121,433.917633 348.680420,343.932800 348.711670,253.947998
	C348.715393,243.186630 357.525513,234.785095 368.760071,234.777420
	C425.750458,234.738510 482.740875,234.756912 539.731262,234.752350
	C558.394775,234.750854 577.060486,234.921936 595.721375,234.697067
	C635.368286,234.219330 670.500061,261.334930 680.707031,299.963745
	C692.361023,344.068970 665.132324,391.540619 621.335876,403.903320
	C592.036743,412.173706 565.300659,406.700592 541.703857,387.286926
	C532.968872,380.100464 527.687012,369.989319 520.784668,361.253540
	C513.127808,351.562927 503.423218,344.825714 491.434357,342.755737
	C471.713196,339.350769 452.730652,347.834503 443.417114,367.149200
	C428.842285,397.375031 450.559113,431.057098 483.303589,431.484009
	C492.829041,431.608185 501.108307,427.412445 508.842102,422.452789
	C517.867554,416.664795 527.057739,411.203949 537.575073,408.915863
	C545.789001,407.128906 554.058044,405.687531 562.725342,406.559692
	C578.275391,408.124451 592.817993,412.309296 605.574585,421.364594
	C624.384338,434.716766 636.821106,452.280243 640.365906,475.626892
	C642.834229,491.883759 641.618103,508.201996 642.014404,524.494019
	C642.110229,528.432739 640.319092,530.201050 636.258118,530.146240
	C626.428467,530.013489 616.595276,530.067322 606.764282,530.140137
	C602.566284,530.171265 600.792908,528.337158 600.839966,524.071106
	C600.968567,512.409302 601.196106,500.732300 600.760620,489.084595
	C600.177612,473.489624 592.172424,461.889435 579.002686,454.327209
	C565.396545,446.514435 551.131653,445.672668 537.266479,454.172241
	C526.459229,460.797302 515.571350,467.039307 503.242371,470.615387
	C480.095551,477.329193 458.709564,472.532562 438.682098,460.675964
	C417.517670,448.146179 404.288879,428.978607 399.205841,405.307556
	C393.041992,376.603180 400.269806,350.613434 420.128448,328.142090
z"
      />
    </svg>
  );
};
